import { render, staticRenderFns } from "./AlarmConfigRule.vue?vue&type=template&id=5768dfb3&scoped=true&"
import script from "./AlarmConfigRule.vue?vue&type=script&lang=js&"
export * from "./AlarmConfigRule.vue?vue&type=script&lang=js&"
import style0 from "./AlarmConfigRule.vue?vue&type=style&index=0&id=5768dfb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768dfb3",
  null
  
)

export default component.exports